import styled from 'styled-components';
import { CSSVars } from '@/styles/styles.config';

export const StyledBrandMarkStrip = styled.div<{ $bg: string; $fg: string }>`
  width: 100%;
  padding: 7px 14px;
  font-family: ${CSSVars.primaryFont}, 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
  letter-spacing: 0.01em;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};

  .bm-seg {
    white-space: nowrap;
  }

  .bm-icon {
    display: inline-block;
    width: 1.35em;
    height: 1.35em;
    margin-right: 6px;
    vertical-align: -0.35em;
  }
`;

export const StyledBrandMarkControl = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin-top: 8px;
  font-size: 13px;
  color: ${CSSVars.gray500};

  button {
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    font-weight: 600;
    color: ${CSSVars.blue500};
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
  }
`;

export const StyledBrandMarkLine = styled.div<{ $fg: string }>`
  padding: 8px 2px 0;
  font-family: ${CSSVars.primaryFont}, 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: ${({ $fg }) => $fg};
  user-select: none;

  .bm-icon {
    display: inline-block;
    width: 1.35em;
    height: 1.35em;
    margin-right: 6px;
    vertical-align: -0.35em;
  }
`;
